import { Entity, repository } from 'aurelia-orm';
import { AppEntity } from "./app-entity";

@repository(ListItem)
export class ListItem extends AppEntity {
	text: String;
	isSaving: Boolean;
}